
// Web socket handling
// This supports the /jumpin mechanism from a slack bot
// TODO: later we may use a /jumpin.../jumpout sequence so that the 
// expert advisor can add multiple lines.  Or make it not a slash command;
// just whatever you type goes to the console (but that will require
// identifying different sessions and having a different channel for each
// one)
export var socket;

export function jumpInInit() {
  // TODO: server runs at 7999, client runs at 8089. So what's 8080?? Is this correct?
  // At the least it should be better documented
  console.log("Inside jumpInInit");
}

var slackNameLinkPresent = false; // When true, we have a hyperlink to use with the name label
var slackNameLink = '';

import {appendMessage} from "../../shared.js";
// TODO move port to a config file
socket = new WebSocket('ws://localhost:8080');

socket.onopen = () => {
  console.log('Connected to the WebSocket server (onopen invoked)');
};

socket.onerror = error => {
    console.error('WebSocket error:', error);
};

// Handle a new /slash command incoming from the web server
socket.onmessage = event => {
  const data = JSON.parse(event.data);
  console.log(`Message from server: "${data.text}" from user "${data.user_name}"`);

  if (data.type === 'channelID') {

    //  this is the client-side recipient of this code on the server side that runs when
    // the channel is initialized:
    //           ws.send(JSON.stringify({ type: 'channelId', channelId })); 

    channelID = data.channelId; // save channel so we can send users messages there
    console.log(`Received channelId from server: ${channelID}`);
  }
  else if (data.command === '/jumpin') {
    // Set a flag to indicate a special response mode
    window.isJumpinCommand = true;
    //alert(`Jumpin command received from ${data.user_name}: ${data.text}`);
    handleJumpIn(data.user_name, data.text);
  }
  else if (data.command === '/linkmyname') {
    // Set a flag to indicate that we should use the linked name
    slackNameLinkPresent = true;
    slackNameLink = data.text;
    // TODO check data.text to ensure it's a legal URL
    //alert(`linkmyname command received from ${data.user_name}: ${data.text}`);
  }
  //else if (data.command == '/exportconvo') {
  // } for matching
  else if (data.command === 'getTextForExport') {
    handleExportConvo(data.channel_id,
      data.response_url, data.user_name, data.googleDriveFolderUrl);
  }
  else alert(`command: ${data.command} not supported`);
};

socket.onclose = () => {
  console.log('Disconnected from WebSocket server');
};


function handleExportConvo(channelID, responseURL, userName, googleDriveFolderUrl) {
  console.log(`Client has received exportconvo request for user "${userName}" and google drive folder: "${googleDriveFolderUrl}"`);

  // Prepare the text to send back to the server
  // TODO later this will be a prettified version of the globalUserMessage array
  const textToSend = makeTextForUpload(messages);

  // For some reason, google drive folder URL arrives with <> around it.  Remove them
  if (googleDriveFolderUrl.startsWith('<') && googleDriveFolderUrl.endsWith('>')) {
    googleDriveFolderUrl = googleDriveFolderUrl.slice(1, -1);
  }

  // Create the message object to send to the server
  const message = {
    command: 'getTextForExport',
    response_url: responseURL,
    text: textToSend,
    googleDriveFolderUrl: googleDriveFolderUrl,
    channel_id: channelID
  };

  // Send the message back to the server via WebSocket
  socket.send(JSON.stringify(message));
}

// Convert messages array to a form that for storing in 
// google docs
// TODO: maybe later I can format this nicely, so that it looks good when it lands in
// the google doc file. For now I'll just leave as a 
// json array
function makeTextForUpload(messagesArray) {
  let filteredMessages = messagesArray.filter(message => message.role !== "system");
  return filteredMessages;
}

async function handleJumpIn(userName, text) {

  // Add the jumpin text to the messages queue with assistant tag on it and some other text that said that expert userName has added the following knowledge to the conversation, which should be taken into account
  // TODO move this text to a data file
  const jumpInHelperText = `A human expert named ${userName} has just added the following custom knowledge to this conversation.  Please take this into account in the remainder of this conversation: ${text}`;

  // echo text to the user screen with the user's name on it
  var userJumpInMessage = '';

  // If we have a hyperlink for the user name then use it
  if (slackNameLinkPresent)
    userJumpInMessage = `<a href="${slackNameLink}" target="_blank">${userName}</a>: ${text}`;
  else userJumpInMessage = `${userName}: ${text}`;
  messages.push({ role: "assistant", content: jumpInHelperText });
  appendMessage(userJumpInMessage, "humanadvisor");

  // ensure that the next turn in the conversation is the user's, not the bot's
  // (nothing particular needed here, it has to do with code that invokes this one)
}
